function initCartOfferSwiper() {
  const slider = document.querySelector('.offers-swiper-cart');
  if (!slider) return;

  if (slider.swiper) {
    slider.swiper.destroy(true, true);
  }

  new Swiper(slider, {
    direction: 'vertical',
    loop: true,
    autoplay: {
      delay: 1800,
      disableOnInteraction: false,
    },
    slidesPerView: 1,
    allowTouchMove: true,
    pagination: {
      el: slider.querySelector('.offers-swiper-fraction'),
      type: 'fraction',
    },
  });
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    // this.observeOfferSlider();
    this.observeReviewsSlider();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  /* --------------------------------------------------
     INIT SWIPER SLIDER (MY CUSTOM FUNCTION)
  -------------------------------------------------- */
  
  observeOfferSlider() {
    const targetNode = document.querySelector('#CartDrawer');

    if (!targetNode) return;

    // Prevent double observer
    if (window._offerSliderObserverAttached) return;
    window._offerSliderObserverAttached = true;

    const observer = new MutationObserver(() => {
      const slider = document.querySelector('.offers-swiper-cart');

      if (slider && !slider.classList.contains('swiper-initialized')) {
        new Swiper(slider, {
          direction: 'vertical',
          loop: true,
          autoplay: {
            delay: 1800,
            disableOnInteraction: false,
          },
          slidesPerView: 1,
          allowTouchMove: true,
        });
      }
    });

    observer.observe(targetNode, {
      childList: true,
      subtree: true
    });
  }


    observeReviewsSlider() {
    const targetNode = document.querySelector('#CartDrawer');

    if (!targetNode) return;

    if (window._offerReviewObserverAttached) return;
    window._offerReviewObserverAttached = true;

    const observer = new MutationObserver(() => {
      const slider = document.querySelector('.cart-reviews-swiper');

      if (slider && !slider.classList.contains('swiper-initialized')) {
        

        const isLoop = slider.dataset.loop === 'true'; 
        const isAutoplay = slider.dataset.autoplay === 'true';
        const playDelay = parseInt(slider.dataset.delay) || 1800;

        new Swiper(slider, {
          loop: isLoop, 
          observer: true,         
          observeParents: true,
          autoplay: isAutoplay ? {
            delay: playDelay,
            disableOnInteraction: false,
          } : false,
          slidesPerView: 1.3,
          spaceBetween: 12,
          allowTouchMove: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          }
        });
      }
    });

    observer.observe(targetNode, {
      childList: true,
      subtree: true
    });
  }




  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
       initCartOfferSwiper();
    }, 150);

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');


    // Start/Resume timer when cart drawer opens
    if (window.CartTimerManager) {
      window.CartTimerManager.start();
    }
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      initCartOfferSwiper();
      

      
      // Re-initialize timer after cart content is rendered
      if (window.CartTimerManager) {
        window.CartTimerManager.start();
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
class CartDiscountComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.input = this.querySelector('input[id="CartDrawer-DiscountCode"]');
    this.button = this.querySelector('.discount-apply-btn');
    this.errorWrapper = this.querySelector('#DiscountError');
    this.details = this.querySelector('details');

    // Restore state after re-render
    if (sessionStorage.getItem('keep-discount-open') === 'true') {
      if (this.details) this.details.setAttribute('open', '');
      sessionStorage.removeItem('keep-discount-open');
    }

    if (sessionStorage.getItem('discount-error-active') === 'true') {
      if (this.errorWrapper) {
        this.errorWrapper.classList.remove('hidden');
        this.errorWrapper.style.display = '';
      }
      sessionStorage.removeItem('discount-error-active');
    }

    // Apply button
    if (this.button) {
      this.button.addEventListener('click', this.applyDiscount.bind(this));
    }

    // Enter key support
    if (this.input) {
      this.input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.applyDiscount();
        }
      });
    }

    // Remove buttons — USE EVENT DELEGATION
    this.addEventListener('click', (e) => {
      // Match the ACTUAL class name from your Liquid template
      const removeBtn = e.target.closest('.remove-discount-btn');
      if (removeBtn) {
        e.preventDefault();
        e.stopPropagation();
        const pill = removeBtn.closest('.cart-discount__pill');
        if (pill && pill.dataset.discountCode) {
          this.removeDiscount(pill.dataset.discountCode);
        }
      }
    });
  }

  getExistingDiscounts() {
    // Match the ACTUAL class and data attribute from Liquid
    return Array.from(this.querySelectorAll('.cart-discount__pill'))
      .map((el) => el.dataset.discountCode)
      .filter(Boolean);
  }

  async applyDiscount() {
    const code = this.input?.value?.trim();
    if (!code) return;

    this.button.disabled = true;
    this.button.textContent = '...';

    sessionStorage.setItem('keep-discount-open', 'true');

    // Hide error
    if (this.errorWrapper) {
      this.errorWrapper.classList.add('hidden');
      this.errorWrapper.style.display = 'none';
    }

    const existingCodes = this.getExistingDiscounts();

    // Duplicate check (case-insensitive)
    if (existingCodes.some((c) => c.toLowerCase() === code.toLowerCase())) {
      this.input.value = '';
      this.button.disabled = false;
      this.button.textContent = 'Apply';
      return;
    }

    const allCodes = [...existingCodes, code].join(',');
    await this.updateCart(allCodes, code);
  }

  async removeDiscount(codeToRemove) {
    sessionStorage.setItem('keep-discount-open', 'true');

    const existingCodes = this.getExistingDiscounts();
    const newCodes = existingCodes.filter((c) => c !== codeToRemove);

    // Add visual feedback
    const pill = this.querySelector(`.cart-discount__pill[data-discount-code="${codeToRemove}"]`);
    if (pill) {
      pill.style.opacity = '0.4';
      pill.style.pointerEvents = 'none';
    }

    await this.updateCart(newCodes.join(','));
  }

  async updateCart(codes, newCode = null) {
    const sectionsToRender = ['cart-drawer', 'cart-icon-bubble'];

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          discount: codes,
          sections: sectionsToRender,
        }),
      });

      const data = await response.json();

      // Check if new code was invalid
      if (newCode) {
        const isApplied =
          data.discount_codes &&
          data.discount_codes.some(
            (d) => d.code.toLowerCase() === newCode.toLowerCase() && d.applicable !== false
          );
        if (!isApplied) {
          sessionStorage.setItem('discount-error-active', 'true');
        }
      }

      // Re-render using Dawn's built-in method
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && data.sections) {
        cartDrawer.renderContents({
          id: cartDrawer.productId,
          sections: data.sections,
        });
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.error('Discount update error:', error);

      // Reset button state on error
      if (this.button) {
        this.button.disabled = false;
        this.button.textContent = 'Apply';
      }
    }
  }
}

if (!customElements.get('cart-discount-component')) {
  customElements.define('cart-discount-component', CartDiscountComponent);
}

document.addEventListener('DOMContentLoaded', function () {
  initCartOfferSwiper();
});